var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _rect2, _path17, _rect3, _path18, _rect4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs3, _path39, _defs4, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.6 95.6",
    style: {
      enableBackground: "new 0 0 67.6 95.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000057116830688812104200000013938578143460496798_);}\n\t.st3{clip-path:url(#SVGID_00000096040953029199367720000003060780917870235810_);}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#BDB6B8;}\n\t.st6{fill:#1A1A1A;}\n\t.st7{fill:#ADA8AA;}\n\t.st8{fill:#262424;}\n\t.st9{fill:#1E8273;}\n\t.st10{fill:#239281;}\n\t.st11{fill:#262626;}\n\t.st12{fill:#0F0F0F;}\n\t.st13{fill:#212226;}\n\t.st14{opacity:0.25;}\n\t.st15{clip-path:url(#SVGID_00000177483647517258582700000002150854136680541115_);}\n\t.st16{opacity:0.15;}\n\t.st17{clip-path:url(#SVGID_00000119834199868767073420000011783378103420057477_);}\n\t.st18{fill:#2B5896;}\n\t.st19{fill:#D71C13;}\n\t.st20{fill:#FF2116;}\n\t.st21{fill:#92130D;}\n\t.st22{fill:#F5F5F5;}\n\t.st23{fill:url(#);}\n\t.st24{fill:#1D7244;}\n\t.st25{fill:#FFFFFF;enable-background:new    ;}\n\t.st26{fill:#207044;enable-background:new    ;}\n\t.st27{fill:#0D6735;}\n\t.st28{fill:#FDFDFD;}\n\t.st29{clip-path:url(#SVGID_00000088814698259926523660000017181916889971372694_);}\n\t.st30{clip-path:url(#SVGID_00000002374461376860227720000016362345755974529435_);}\n\t.st31{fill:#F5F5F7;}\n\t.st32{fill:#142736;}\n\t.st33{fill:#1d3943;}\n\t.st34{clip-path:url(#SVGID_00000027599685812899680700000012896299855066522556_);}\n\t.st35{clip-path:url(#SVGID_00000170971391547130973320000016359369651271078572_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176035433286377857130000017651793074463324598_",
    x: 0.6,
    y: 0.8,
    width: 66.5,
    height: 93.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123403773903110235410000014781426708469482896_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176035433286377857130000017651793074463324598_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4362_00000176007038941321251060000000457122401193988541_",
    style: {
      clipPath: "url(#SVGID_00000123403773903110235410000014781426708469482896_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4361_00000116937970584158534060000003359660786017453185_",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000033356129161375894430000007333394568540182424_",
    x: 0.6,
    y: 0.8,
    width: 66.5,
    height: 93.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121274362039088011570000001506535166249293973_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033356129161375894430000007333394568540182424_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4360_00000140697176018024670930000015545741133871877258_",
    style: {
      clipPath: "url(#SVGID_00000121274362039088011570000001506535166249293973_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7513_00000107569659950453931190000010878049883859907997_",
    className: "st31",
    d: "M67,85.9c0,4.9-14.9,8.9-33.2,8.9 s-33.2-4-33.2-8.9c0-4.9,14.9-8.9,33.2-8.9S67,80.9,67,85.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7514_00000147198367569164360380000003402115832518094265_",
    className: "st5",
    d: "M20.9,2.8h25.8c0.7,0,1.4,0.2,2,0.6 c-0.2-1.5-1.5-2.6-3-2.6H22c-1.5,0-2.8,1.1-3,2.6C19.6,3,20.2,2.8,20.9,2.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7515_00000078738634124261130640000013420546404104214160_",
    className: "st6",
    d: "M41.6,61.5l2,1.2l0.4-0.7l-2-1.2 c-0.9-0.5-1.3-1.6-1.1-2.6L40.2,58C39.9,59.4,40.4,60.8,41.6,61.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7516_00000154417402926916582700000009803307408488303768_",
    d: "M44.8,63.7L43.6,63c-0.2-0.1-0.3-0.4-0.2-0.7 c0,0,0,0,0,0l0.2-0.4c0.1-0.2,0.4-0.3,0.7-0.2c0,0,0,0,0,0l1.2,0.7c0.2,0.1,0.3,0.4,0.2,0.7c0,0,0,0,0,0l-0.2,0.4 C45.3,63.7,45,63.8,44.8,63.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7517_00000105427462801553199410000000464934492006367656_",
    className: "st7",
    d: "M51.5,41.8l-0.1-1.2l-0.1-1.2 L51.2,37l-0.3-4.8L50.9,31l-0.1-1.2l-0.2-2.4l-0.3-4.8l-0.4-4.8l-0.2-2.4l-0.1-1.2l-0.1-1.2l-0.4-4.8L48.9,6l-0.1-1.2l-0.1-1.2 l0,0c-0.1-1.6-1.4-2.8-3-2.8H22c-1.6,0-2.9,1.2-3,2.8l-0.1,1.2L18.7,6l-0.2,2.4l-0.4,4.8L18,14.3l-0.1,1.2l-0.2,2.4l-0.4,4.8 L17,27.5l-0.2,2.4L16.8,31l-0.1,1.2L16.4,37l-0.1,2.4l-0.1,1.2l-0.1,1.2l0,0c-0.1,2.3,1.7,4.3,4,4.5c0.1,0,0.1,0,0.2,0h26.8 c2.3,0,4.3-1.9,4.3-4.3C51.5,41.9,51.5,41.8,51.5,41.8L51.5,41.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7518_00000007412925180748811100000001437287954741445767_",
    d: "M54.8,54.2v-2.7c1.7,0,3.1-1,3.1-2.3l0.2-4.9 c0.1-1.3-0.6-2.6-1.8-3.6c-1.3-1-2.9-1.5-4.6-1.5h-3.2v-2.7h3.2c2.6,0,5.1,0.8,7.1,2.3c1.9,1.5,2.9,3.5,2.8,5.6l-0.2,4.9 c-0.1,1.3-0.8,2.6-2,3.5C58,53.7,56.4,54.2,54.8,54.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7519_00000070828159026486330480000014607347013206354104_",
    d: "M54.8,54.2v-2.7c1.7,0,3.1-1,3.1-2.3l0.2-4.9 c0.1-1.3-0.6-2.6-1.8-3.6c-1.3-1-2.9-1.5-4.6-1.5h-3.2v-2.7h3.2c2.6,0,5.1,0.8,7.1,2.3c1.9,1.5,2.9,3.5,2.8,5.6l-0.2,4.9 c-0.1,1.3-0.8,2.6-2,3.5C58,53.7,56.4,54.2,54.8,54.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7520_00000022526014336791507010000008349102165879286200_",
    className: "st8",
    d: "M58.9,38.8c-2-1.6-4.5-2.4-7.1-2.3 h-3.2l0,0c2.6,0,5.1,0.7,6.9,2.1c1.9,1.3,2.8,3.1,2.7,4.9l-0.2,5.8c-0.1,1.3-1.4,2.3-3.1,2.3v2.7c1.6,0,3.3-0.5,4.6-1.4 c1.2-0.9,2-2.2,2-3.5l0.2-4.9C61.7,42.3,60.7,40.3,58.9,38.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7521_00000176737142381730727320000000903085903458949765_",
    d: "M12.9,54.2v-2.7c-1.7,0-3.1-1-3.1-2.3l-0.2-4.9 c-0.1-1.3,0.6-2.6,1.8-3.6c1.3-1,2.9-1.5,4.6-1.5h3.2v-2.7h-3.2c-2.6,0-5.1,0.8-7.1,2.3c-1.9,1.5-2.9,3.5-2.8,5.6l0.2,4.9 c0.1,1.3,0.8,2.6,2,3.5C9.6,53.7,11.2,54.2,12.9,54.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7522_00000103948101316794651520000003304898688212880794_",
    d: "M12.9,54.2v-2.7c-1.7,0-3.1-1-3.1-2.3l-0.2-4.9 c-0.1-1.3,0.6-2.6,1.8-3.6c1.3-1,2.9-1.5,4.6-1.5h3.2v-2.7h-3.2c-2.6,0-5.1,0.8-7.1,2.3c-1.9,1.5-2.9,3.5-2.8,5.6l0.2,4.9 c0.1,1.3,0.8,2.6,2,3.5C9.6,53.7,11.2,54.2,12.9,54.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7523_00000128485245794279431260000017293893469263422141_",
    className: "st8",
    d: "M12.2,38.5c1.8-1.3,4.3-2,6.9-2.1 l0,0h-3.2c-2.6,0-5.1,0.8-7.1,2.3c-1.9,1.5-2.9,3.5-2.8,5.6l0.2,4.9c0.1,1.3,0.8,2.6,2,3.5c1.3,1,3,1.5,4.6,1.4v-2.7 c-1.7,0-3.1-1-3.1-2.3l-0.2-5.8C9.4,41.6,10.4,39.8,12.2,38.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7524_00000032614246584635231600000018210246549379133105_",
    d: "M56.7,52.9c0-1.2-0.4-2.3-1.2-3.1 c-2.1-2.2-5-3.5-8-3.5H20.1c-3,0-5.9,1.3-8,3.5c-0.8,0.9-1.2,2-1.2,3.1c0,3.9,2.9,7,6.4,7h33C53.9,59.9,56.7,56.8,56.7,52.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7525_00000114782562768227754580000011147792611665118877_",
    className: "st32",
    d: "M55.5,49.4c-2.2-2-5-3.2-8-3.2H20.1 c-3,0-5.8,1.1-8,3.2c-0.8,0.7-1.2,1.8-1.2,2.9c0,3.5,2.9,6.4,6.4,6.4h33c3.5,0,6.4-2.9,6.4-6.4C56.7,51.2,56.3,50.2,55.5,49.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7526_00000070099991505261601890000005629450485263020959_",
    className: "st33",
    d: "M51.6,55.7H16.1c-1.9,0-3.6-0.7-5-2 c0.7,2.9,3.3,4.9,6.2,4.9h33c3,0,5.6-2.1,6.2-4.9C55.2,55,53.4,55.7,51.6,55.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7527_00000162310636760045474740000018148683525935942290_",
    className: "st33",
    d: "M33.8,46.2h13.4 c2.3,0,4.3-1.9,4.3-4.3c0-0.1,0-0.2,0-0.3L48.7,3.6c-0.1-1.6-1.4-2.8-3-2.8H22c-1.6,0-2.9,1.2-3,2.8l-2.8,38.1 c-0.2,2.3,1.6,4.4,3.9,4.6c0.1,0,0.2,0,0.3,0L33.8,46.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7528_00000013154479399668952310000001797877315102624902_",
    className: "st32",
    d: "M51.4,40.6l-0.1-1.2L51.2,37 l-0.3-4.8L50.9,31l-0.1-1.2l-0.2-2.4l-0.3-4.8l-0.4-4.8l-0.2-2.4l-0.1-1.2l-0.1-1.2l-0.4-4.8L48.9,6l-0.1-1.2l-0.1-1.2 l-0.4,0.8l0,0c-1,2-1.5,4.2-1.3,6.5l0.1,1.6l-3.1,0l-3.6,0l-7.2,0l-7.2,0l-3.6,0l-1.8,0l0.1-1.6c0.2-2.2-0.3-4.5-1.3-6.5l0,0 L19,3.6l-0.1,1.2L18.7,6l-0.2,2.4l-0.4,4.8L18,14.3l-0.1,1.2l-0.2,2.4l-0.4,4.8L17,27.5l-0.2,2.4L16.8,31l-0.1,1.2L16.4,37 l-0.1,2.4l-0.1,1.2l-0.1,1.2l0.6-0.8l0,0c1.3-1.8,2-3.9,2.2-6.1l0-0.1c2.4,0.3,4.8,0.5,7.1,0.7c2.7,0.2,5.4,0.2,8.1,0.2 c2.7,0,5.4-0.1,8.1-0.2c2.2-0.1,4.3-0.3,6.5-0.6l0,0c0.2,2.2,0.9,4.3,2.2,6.1l0,0l0.6,0.8L51.4,40.6z M26,13.4 c2.4,0.2,4.8,0.2,7.2,0.2c2.4,0,4.8-0.1,7.2-0.2c2.2-0.1,4.5-0.3,6.7-0.7l0.8,10.8l-2.3,0l-4,0l-8.1,0l-8.1,0l-4,0l-1.6,0 l0.8-10.6C22.3,13.1,24.2,13.3,26,13.4 M46.3,34.5l-4,0l-8.1,0l-8.1,0l-4,0l-3.1,0l0.8-10.6c1.9,0.2,3.8,0.4,5.7,0.5 c2.7,0.2,5.4,0.2,8.1,0.2c2.7,0,5.4-0.1,8.1-0.2c2.1-0.1,4.2-0.3,6.3-0.6l0.8,10.6L46.3,34.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042_00000145741535275789804550000000131146032477144246_",
    x: 49.9,
    y: 77.9,
    width: 2.3,
    height: 2.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7529_00000057866921336945514290000008456664647119256974_",
    className: "st11",
    d: "M53.1,81c0,1.1-0.9,2.1-2.1,2.1 c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1S53.1,79.8,53.1,81L53.1,81"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7530_00000070796950362630574770000004601232295633804208_",
    d: "M53,81.1c0,0.9-0.8,1.7-1.7,1.7 c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h0C52.2,79.4,53,80.2,53,81.1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043_00000002355394410865061830000010032601327965287855_",
    x: 14.2,
    y: 77.9,
    width: 2.3,
    height: 2.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7531_00000052088333151998968650000007428688467732227993_",
    className: "st11",
    d: "M17.4,81c0,1.1-0.9,2.1-2.1,2.1 s-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1C16.5,78.9,17.4,79.8,17.4,81L17.4,81"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044_00000013189451026590941620000005286017630660736167_",
    x: 17.5,
    y: 87.3,
    width: 2.3,
    height: 2.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7532_00000054262394801288562870000013342313694428046471_",
    className: "st11",
    d: "M20.7,90.5c0,1.1-0.9,2.1-2.1,2.1 c-1.1,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1C19.8,88.4,20.7,89.3,20.7,90.5L20.7,90.5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045_00000087404836380153407420000011041701208484524185_",
    x: 46.8,
    y: 87.3,
    width: 2.3,
    height: 2.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7533_00000119090047894854252300000015641382907940118966_",
    className: "st11",
    d: "M50.1,90.5c0,1.1-0.9,2.1-2.1,2.1 s-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1S50.1,89.3,50.1,90.5L50.1,90.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7534_00000183957623399308197080000005588932977108614577_",
    className: "st8",
    d: "M17.6,88.5l18.9-10 c0.2-0.1,0.3-0.4,0.2-0.6c0,0,0,0,0,0l-1.2-2.2c-0.1-0.2-0.4-0.3-0.6-0.2c0,0,0,0,0,0l-17.6,9.3c-0.9,0.5-1.3,1.6-0.8,2.6 c0,0,0,0,0,0l0.5,0.9C17.1,88.6,17.4,88.7,17.6,88.5C17.6,88.6,17.6,88.6,17.6,88.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7535_00000059275216329333759730000003856481522728886945_",
    className: "st8",
    d: "M50.4,75.2H33.2v3.4h19.3 c0.4,0,0.7-0.3,0.7-0.7C53.1,76.5,51.9,75.2,50.4,75.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7536_00000085226588065875833070000000291760922888543629_",
    className: "st8",
    d: "M49,88.5l-18.9-10 c-0.2-0.1-0.3-0.4-0.2-0.6c0,0,0,0,0,0l1.2-2.2c0.1-0.2,0.4-0.3,0.6-0.2c0,0,0,0,0,0l17.6,9.3c0.9,0.5,1.3,1.6,0.8,2.6 c0,0,0,0,0,0l-0.5,0.9C49.5,88.6,49.2,88.7,49,88.5C49,88.6,49,88.6,49,88.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7537_00000036941895341368756740000010139669095094578329_",
    className: "st12",
    d: "M48.6,84.4l-16.7-8.8 c-0.3-0.2-0.7,0-0.9,0.3l-0.2,0.5c0.2-0.1,0.5-0.2,0.7,0l16.7,8.8c1.2,0.6,1.8,2,1.3,3.3c0.1-0.1,0.2-0.2,0.3-0.3 C50.4,86.8,49.9,85.2,48.6,84.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7538_00000090993033109442195540000012211479517476311203_",
    className: "st8",
    d: "M16,75.2c-1.5,0-2.8,1.2-2.8,2.8 c0,0.4,0.3,0.7,0.7,0.7h19.3v-3.4H16z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7539_00000179627693796451129030000018186334148467918506_",
    className: "st12",
    d: "M50.4,75.2H33.2v0.9h17.2 c1.3,0,2.4,0.9,2.7,2.1c0-0.1,0.1-0.2,0.1-0.3C53.1,76.5,51.9,75.2,50.4,75.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7540_00000067198112082504535780000008211008949453632957_",
    d: "M36.7,61.4h-7c-0.4,0-0.8,0.3-0.8,0.8v0.4 c0,0.6,0.5,1.1,1.1,1.1h6.3c0.6,0,1.1-0.5,1.1-1.1v-0.4C37.5,61.7,37.1,61.4,36.7,61.4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7541_00000096774112613027884650000008485346877937903520_",
    className: "st8",
    d: "M37.7,62.2h-9.1 c-0.5,0-0.9-0.4-0.9-0.9l0,0v-1.3h10.9v1.3C38.7,61.8,38.2,62.2,37.7,62.2L37.7,62.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7542_00000011714778666429724760000014837193669427831987_",
    className: "st8",
    d: "M37.3,62.5h-8.3c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c0,0.6,0.5,1.1,1.1,1.1h0h6.3c0.6,0,1.1-0.5,1.1-1.1l0,0c0,0,0,0,0,0C37.4,62.5,37.4,62.5,37.3,62.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7543_00000176003128864899751830000013649320663169505420_",
    className: "st12",
    d: "M35,75.6c-0.1,0-0.2,0-0.2,0.1 L18,84.4c-1.3,0.7-1.9,2.4-1.2,3.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.4-1.3,0.1-2.7,1.3-3.3L35,76.5L35,75.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7544_00000059272763330745028610000015021155180129382312_",
    className: "st12",
    d: "M16,75.2c-1.5,0-2.8,1.2-2.8,2.8 c0,0.1,0,0.2,0.1,0.3c0.3-1.3,1.4-2.1,2.7-2.1h17.2v-0.9H16z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7545_00000017492487058930530450000009004914592996115377_",
    d: "M31.1,68.7v8.4c0,0.4,0.9,0.7,2,0.7 c1.1,0,2-0.3,2-0.7v-8.4H31.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7546_00000168837588247831961860000012842492118443025815_",
    className: "st6",
    d: "M35.2,68.7c0,0.4-0.9,0.7-2,0.7 s-2-0.3-2-0.7c0-0.4,0.9-0.7,2-0.7S35.2,68.3,35.2,68.7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7547_00000031179304541080340170000013941929550803279536_",
    className: "st8",
    d: "M32.1,66.7v1.8 c0,0.2,0.5,0.4,1.1,0.4c0.6,0,1.1-0.2,1.1-0.4v-1.8H32.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7548_00000137854046746932252540000015711754638282775185_",
    d: "M34.8,66.9h-3.2c-0.2,0-0.4-0.2-0.4-0.4v-2.8h4.1 v2.8C35.2,66.7,35,66.9,34.8,66.9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7549_00000065045157194962405910000003269187486032178620_",
    d: "M49.8,90.7c0,0.9-0.8,1.7-1.7,1.7 s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7h0C49.1,89,49.8,89.7,49.8,90.7C49.8,90.7,49.8,90.7,49.8,90.7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7550_00000161632861280706600400000006598953691970146983_",
    d: "M20.5,90.6c0,0.9-0.8,1.7-1.7,1.7 c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0C19.7,89,20.5,89.7,20.5,90.6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7551_00000029741810356162851440000013273761540003352204_",
    d: "M17.1,81.2c0,0.9-0.8,1.7-1.7,1.7 c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0C16.4,79.5,17.1,80.2,17.1,81.2C17.1,81.2,17.1,81.2,17.1,81.2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7552_00000008863737238191041450000011184982232143644554_",
    className: "st13",
    d: "M34.8,3.1c0.1,0.4-0.2,0.8-0.7,0.9 c-0.4,0.1-0.8-0.2-0.9-0.7c-0.1-0.4,0.2-0.8,0.7-0.9c0,0,0,0,0,0C34.3,2.3,34.7,2.6,34.8,3.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4356_00000116201955799394970950000011261985289511278726_",
    transform: "translate(101.168 4.756)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4355_00000103246392280755511190000016353674212005704110_"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018214829317478155930000006826078902514410673_",
    x: -68,
    y: -2.4,
    width: 1.8,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124884105553664349100000003490065106339246502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018214829317478155930000006826078902514410673_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4354_00000109749701629837565320000005275322496415073168_",
    style: {
      clipPath: "url(#SVGID_00000124884105553664349100000003490065106339246502_)"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7553_00000182530734889202089830000006199485846731259530_",
    d: "M-66.2-1.6c0.1,0.5-0.3,1-0.8,1 c-0.5,0.1-1-0.3-1-0.8c-0.1-0.5,0.3-1,0.8-1c0,0,0,0,0,0C-66.7-2.5-66.3-2.1-66.2-1.6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4359_00000103967766586572263050000006240027257240528280_",
    transform: "translate(63.888 7.213)",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4358_00000111189207199175973320000001718581872566152074_"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000043416932705777335480000006954880048585811856_",
    x: -42.7,
    y: -4.1,
    width: 27.2,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118358956077682442730000005591682086185611435_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043416932705777335480000006954880048585811856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4357_00000142138855210258169280000010921238653251065501_",
    style: {
      clipPath: "url(#SVGID_00000118358956077682442730000005591682086185611435_)"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7554_00000030464893460277781520000007606770635212718210_",
    d: "M-16.4,6L-19,6l-9.2-9.6 c-0.2-0.3-0.6-0.4-1-0.4c-0.4,0-0.7,0.1-1,0.4l-9.1,9.6l-2.6,0c-0.5,0-0.8,0.4-0.8,0.8c0,0,0,0,0,0l0,14.3 c0,0.5,0.4,0.8,0.8,0.8l25.5,0.1c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0l0-14.3C-15.6,6.4-16,6-16.4,6 M-29.9-3.4 c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3l8.9,9.4l-19.2-0.1L-29.9-3.4z"
  })))))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7555_00000057855755983016677030000009391255394704530851_",
    className: "st0",
    d: "M45.4,14.6c-0.1,0-0.1,0-0.1-0.1 l-10.8-11c-0.4-0.4-1-0.4-1.3,0c0,0,0,0,0,0l-10.8,11c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0l10.8-11 c0.5-0.5,1.4-0.5,1.9,0c0,0,0,0,0,0l10.8,11c0.1,0.1,0.1,0.2,0,0.3C45.5,14.6,45.5,14.6,45.4,14.6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7556_00000171711321297223544360000009324893169014895517_",
    className: "st0",
    d: "M46.6,28.2l-25.5,0 c-0.5,0-0.8-0.4-0.8-0.8c0,0,0,0,0,0v-14c0-0.5,0.4-0.8,0.8-0.8c0,0,0,0,0,0l25.5,0c0.5,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0v14 C47.4,27.9,47,28.2,46.6,28.2L46.6,28.2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7557_00000054261485649005486990000016309425335028271242_",
    className: "st13",
    d: "M34.7,3.1c0.1,0.5-0.3,0.9-0.7,1 c-0.5,0.1-0.9-0.3-1-0.7c-0.1-0.5,0.3-0.9,0.7-1c0,0,0,0,0,0C34.2,2.3,34.6,2.6,34.7,3.1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.da13d7abf30d4133a03ec497b4d12ae3.svg";
export { ForwardRef as ReactComponent };